import { useRef, useEffect } from 'react';

function usePureDocumentTitle(title: string, retainOnUnmount = false) {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    return () => {
      if (!retainOnUnmount) {
        document.title = defaultTitle.current;
      }
    };
  }, []);
}

const useDocumentTitle = (value?: string) => {
  let pageTitle = 'Mineko.de';
  if (value) {
    pageTitle = `${value} | ${pageTitle}`;
  }
  usePureDocumentTitle(pageTitle);
};

export default useDocumentTitle;
